export type Snackbar = {
  uuid: string
  message: string
  type: SnackbarType
  theme: SnackbarTheme
  location: SnackbarLocation
  timeout: number
  hyphens?: boolean
}

export const enum SnackbarType {
  MESSAGE = 'message',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

export const enum SnackbarTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export const enum SnackbarLocation {
  TOP = 'top',
  BOTTOM = 'bottom',
}
